import { g as global$1 } from './index.esm-7182addc.js';

function toggleBodyScrolling(value) {
    const body = global$1.document.body;
    if (body) {
        if (value === 'off') {
            body.style.overflow = 'hidden';
        }
        else {
            body.removeAttribute('style');
        }
    }
}

export { toggleBodyScrolling as t };

//# sourceMappingURL=toggleBodyScrolling-727a628b.js.map